// eslint-disable-next-line import/no-cycle
import ajax from '../../../../../scanline/utils/ajax';
import { hasAccessToken } from '../../../../../scanline/utils/token';

import { transformHttpCustomers } from './util';

export const fetchCustomers = callback => {
	if (hasAccessToken()) {
		ajax(
			`/rel/customers`,
			null,
			'GET',
			(err, res) => {
				if (err) {
					callback(err);
				} else {
					const customers = transformHttpCustomers({ list: res });

					callback(null, customers);
				}
			},
			undefined,
			'admin'
		);
	}
};

export default { fetchCustomers };
